import { API_BASE_PATH } from '../config/api-base-path';

export function backendUrl(path: string): string {
  return `${API_BASE_PATH}/${path.replace(/^\//, '')}`;
}

/** True iff the URL targets the same-origin backend API below `API_BASE_PATH`. */
export function isBackendUrl(url: string): boolean {
  try {
    const origin = globalThis.location.origin;
    const requestUrl = new URL(url, origin);

    return (
      requestUrl.origin === new URL(origin).origin &&
      (requestUrl.pathname === API_BASE_PATH || requestUrl.pathname.startsWith(`${API_BASE_PATH}/`))
    );
  } catch {
    return false;
  }
}
